module.exports = __webpack_public_path__ + "img/9788954430074.55bff907.jpg";